import { utils } from '@adc/ui-adc'
import { contactNumbers, internationalization } from '@adc/constants'

/**
 * We store error message to store on the client based on error codes
 * that the API gives back to us.
 */

/**
 * We should never really be showing this error. It is a last resort that gives the user feedback
 * if we encounter an error code we are not explicitly handling in this application.
 */
export const defaultMessage = 'There was an error handling your request.'

/**
 * Bidding
 *
 * NOTE: I have only brought over messages that we *need* right now. We might need to bring more
 * across later.
 */
export const BD002 = 'Bid Amount is Invalid.'
export const BD003 = 'The amount entered is below the minimum bid.'
export const BD004 = 'Auction not started.'
export const BD005 = 'Auction already ended.'
export const BD006 = 'You are not registered for this Auction.'
export const BD009 = 'Proxy bidding is not allowed for this auction.'
export const BD010 = 'Proxy bids are not allowed after the auction starts.'
export const BD011 = 'You already have a higher proxy bid.'
// for now, double referencing these variables to avoid defining the same string twice, once v1 is removed, then the BD variables can also go away and the new codes
// can correspond directly to the string
export const HIGHER_BID_ALREADY_EXIST_FOR_LISTING = BD002
export const INVALID_STARTING_BID = BD003
export const NO_ACTIVE_ONLINE_SEGMENT_FOUND_FOR_LISTING = BD004
export const PARTY_NOT_REGISTERED = BD006
export const PARTY_PARTICIPATION_DISALLOWED = `You have been disabled from bidding on this property. Please call ${utils.formatters.formatPhoneNumber(
  contactNumbers.ONLINE_BUYER_EXPERIENCE
)} and our Buyer Experience Team will assist you.`

export const INVALID_MAX_BID_UPDATE_WINDOW =
  internationalization.invalid_max_bid_update_window
export const INVALID_MAX_BID_UPDATE =
  internationalization.invalid_max_bid_update
